import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import useCategoryProductListQueryOption from '../../category/useCategoryProductListQueryOption';
import { CATEGORY } from '../../../constants/queryKeys';
import { CATEGORY_PRODUCT_LIST_FILTER_OPTION_MODEL } from '../../../store/modules/category/models';
import { LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
/**
 * 검색한 카테고리 상품 리스트를 요청하는 query hook
 * @param {number} categoryId - 카테고리 ID
 * @param {object} options - react-query options 객체
 * @return {UseQueryResult<{filterOption: {brandName: (Array<string|boolean|number|null>|string|boolean|number|null), productId: (Array<string|boolean|number|null>|string|boolean|number|null), brandId: (Array<string|boolean|number|null>|string|boolean|number|null), productStatus: (Array<string|boolean|number|null>|string|boolean|number|null), orderBy: (Array<string|boolean|number|null>|string|boolean|number), sortBy: (Array<string|boolean|number|null>|string|boolean|number), brandStatus: (Array<string|boolean|number|null>|string|boolean|number|null), productName: (Array<string|boolean|number|null>|string|boolean|number|null)}, pagination: {pages: number, pageSize: number, pageNum: number}}, unknown>}
 */
const useCategoryProductList = (categoryId, options) => {
  const { search = '' } = useLocation();
  const { setQueryString, queryFn } = useCategoryProductListQueryOption();
  const { data } = useQuery(
    [...CATEGORY.PRODUCT_LIST, search],
    () => queryFn(categoryId, setQueryString(search, options)),
    options,
  );

  return (
    data || {
      products: [],
      totalCount: null,
      filterOption: CATEGORY_PRODUCT_LIST_FILTER_OPTION_MODEL,
      pagination: LIST_PAGINATION_MODEL,
    }
  );
};

export default useCategoryProductList;
